export default __webpack_public_path__ + "static/article-travel-last-minute-4d8d40d49a00fbe9050d4f75d9ca61b0.jpg";